import {LABEL_ASSIGNMENT_GET , LABEL_ASSIGNMENT_SUCCESS,LABEL_ASSIGNMENT_FAILURE} from './actions';

const initialState = {
    order: {},
    request:{},
}

export function LabelAssignmentReducer(state = initialState, action) {
    
    if(action.type === LABEL_ASSIGNMENT_GET) {
        return state;
    }
    if(action.type === LABEL_ASSIGNMENT_SUCCESS) {
        return {
            ...state,
            order: {
                isLoaded: true,
                data: action.payload.res,
                message: 'Success'
            },
            request:action.payload.request
            
        }
    }
    if(action.type === LABEL_ASSIGNMENT_FAILURE) {
        return {
            ...state,
            order: {
                data: [],
                message: action.payload.message
            },
            request:action.payload.request
        }
    }
    
    return state;
    
}



